// ts-gql-integrity:809a0abeb70b8db0900542a36c20f6c4
/*
ts-gql-meta-begin
{
  "hash": "4a24cb2954916f325d4b71639e8ed2cb"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type Job_RecurrenceFragmentFragment = { recurrence: { cloudId: string, nextDateUtc: any | null, enabled: boolean, recurrenceFrequency: SchemaTypes.RecurrenceFrequency | null } };



export type type = TypedDocumentNode<{
  type: "fragment";
  result: Job_RecurrenceFragmentFragment;
  name: "Job_RecurrenceFragment";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    Job_RecurrenceFragment: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"Job_RecurrenceFragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Job\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurrence\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cloudId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"nextDateUtc\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"enabled\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurrenceFrequency\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
